<div class="main-container">
    <div class="sub-container-header" *ngIf="headerData.userName">
        <div>
            <span class="start-info cursorPointer" (click)="onNavigateBack()">{{headerData.userName}}</span> <span class="slash-info">/</span> <span class="end-info">{{headerData.name ? headerData.name : 'Programs'}}</span>
        </div>
        <div class="white program-info">
            {{headerData.name}}
            <span class="close_icon" (click)="onNavigateBackUser()">
                <mat-icon>close</mat-icon>
            </span>
        </div>
        <div class="sub-title">{{headerData.duration}}</div>
    </div>
    <div class="body-content">
        <mat-tab-group mat-align-tabs="start" >
            <mat-tab label="Sessions">
                <div class="main-content">
                    <div class="body-sub-info">
                        <div class="sessions-header">Sessions</div>
                        <div>
                            <div class="add-session" (click)="addSession()">ADD SESSION</div>
                            <div class="add-session" (click)="noSessionsFound ? '' : copySessionPopUp()" [ngClass]="{'disable_div':noSessionsFound}">COPY SESSION</div>
                        </div>
                    </div>
                    <div class="sessions-container">
                        <table mat-table [dataSource]="sessionsTableData" class="mat-elevation-z10" >
                            <ng-container matColumnDef="name">
                                <th mat-header-cell *matHeaderCellDef> NAME </th>
                                <td mat-cell *matCellDef="let element"> 
                                    <div class="client-name">{{element.name}}</div> 
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="date">
                                <th mat-header-cell *matHeaderCellDef> SESSION DATE </th>
                                <td mat-cell *matCellDef="let element"> 
                                    <div class="client-name">{{commonService.getFormattedDate(element.program_start_date)}}</div> 
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="weight">
                                <th mat-header-cell *matHeaderCellDef> WEIGHT </th>
                                <td mat-cell *matCellDef="let element"> 
                                    <div class="client-name">{{element.weights.length > 0 ? element.weights[0].weight : ''}}</div> 
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="bodyfat">
                                <th mat-header-cell *matHeaderCellDef> BODY FAT </th>
                                <td mat-cell *matCellDef="let element"> 
                                    <div class="client-name">{{element.weights.length > 0 ? element.weights[0].bodyfat : ''}}</div> 
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="status">
                                <th mat-header-cell *matHeaderCellDef> STATUS </th>
                                <td mat-cell *matCellDef="let element"> 
                                    <div class="client-name" *ngIf="activeProgramId === element.id">Active</div>
                                    <div class="client-name" *ngIf="activeProgramId !== element.id">In Active</div>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row class="cursorPointer" *matRowDef="let row; columns: displayedColumns;" (click)="onProgramSelection(row)"></tr>
                        </table>
                        <div *ngIf="noSessionsFound">
                            No sessions found
                        </div>
                    </div>
                </div>                
            </mat-tab>
            <mat-tab label="Goals">
                <div class="main-content">
                    <div class="goals-container">
                        <div class="metrics-row">
                            <div class="start-data">
                                <h3 class="section-title">Starting Metrics</h3>
                                <div class="metric-row">
                                    <span class="lbl">Start Weight</span>
                                    <span class="vals">{{goalsData?.start_weight}} lbs</span>
                                </div>
                                <div class="metric-row">
                                    <span class="lbl">Start Body Fat</span>
                                    <span class="vals">{{goalsData?.start_bodyfat}} %</span>
                                </div>
                                <div class="metric-row">
                                    <span class="lbl">Start Lean Mass</span>
                                    <span class="vals">{{goalsData?.start_leanmass}} lbs</span>
                                </div>
                                <div class="metric-row">
                                    <span class="lbl">Start Fat Mass</span>
                                    <span class="vals">{{goalsData?.start_fatmass}} lbs</span>
                                </div>
                                <div class="metric-row">
                                    <span class="lbl">Start Date</span>
                                    <span class="vals">{{start_date}}</span>
                                </div>
                                <div class="metric-row">
                                    <span class="lbl">Sessions to Goal</span>
                                    <span class="vals">{{goalsData?.weekstogoal}}</span>
                                </div>
                            </div>

                            <div class="goal-data">
                                <h3 class="section-title">Target Goals</h3>
                                <div class="metric-row">
                                    <span class="lbl">Goal Weight</span>
                                    <span class="vals">{{goalsData?.goal_weight}} lbs</span>
                                </div>
                                <div class="metric-row">
                                    <span class="lbl">Goal Body Fat</span>
                                    <span class="vals">{{goalsData?.goal_bodyfat}} %</span>
                                </div>
                                <div class="metric-row">
                                    <span class="lbl">Goal Lean Mass</span>
                                    <span class="vals">{{goalsData?.goal_leanmass}} lbs</span>
                                </div>
                                <div class="metric-row">
                                    <span class="lbl">Goal Fat Mass</span>
                                    <span class="vals">{{goalsData?.goal_bodyfat_pounds}} lbs</span>
                                </div>
                                <div class="metric-row">
                                    <span class="lbl">End Date</span>
                                    <span class="vals">{{end_date}}</span>
                                </div>
                                <div class="metric-row">
                                    <span class="lbl">Sessions Purchased</span>
                                    <span class="vals">{{goalsData?.packagepurchased}}</span>
                                </div>
                            </div>

                            <div class="program_differ_Data">
                                <h3 class="section-title">Progress Tracking</h3>
                                <div class="metric-row">
                                    <span class="lbl">Weight Change</span>
                                    <span class="vals">{{commonService.fixedDecimal(goalsData?.goal_weight - goalsData?.start_weight)}} lbs</span>
                                </div>
                                <div class="metric-row">
                                    <span class="lbl">Body Fat Change</span>
                                    <span class="vals">{{commonService.fixedDecimal(goalsData?.goal_bodyfat - goalsData?.start_bodyfat)}} %</span>
                                </div>
                                <div class="metric-row">
                                    <span class="lbl">Lean Mass Change</span>
                                    <span class="vals">{{commonService.fixedDecimal(goalsData?.goal_leanmass - goalsData?.start_leanmass)}} lbs</span>
                                </div>
                                <div class="metric-row">
                                    <span class="lbl">Fat Mass Change</span>
                                    <span class="vals">{{commonService.fixedDecimal(goalsData?.goal_bodyfat_pounds - goalsData?.start_fatmass)}} lbs</span>
                                </div>
                                <div class="metric-row">
                                    <span class="lbl">Sessions To Goal</span>
                                    <span class="vals">{{commonService.getWeaksDiffer(end_date, start_date)}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>                
            </mat-tab>
        </mat-tab-group>
    </div>
</div>